// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3PaVC","head":"Table_head__3WtJP","col":"Table_col__1MNZo"};